import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    public toasterService: ToastrService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    if (state.url.includes('auth-callback') || this.authService.isAuthCallbackRoute(state.url)) {
      return true;
    }

    if (!this.authService.isAuthenticated()) {
      const attempted = state && state.url && state.url !== '/' ? state.url : undefined;

      //this.authService.setRedirectedFromProtectedRoute(true, attempted);

      await this.authService.login();

      return false;
    }

    const requiredRoles: string[] = route.data && route.data.roles ? route.data.roles : [];

    if (requiredRoles.length > 0) {
      const userRoles: string[] = this.authService.roles || [];
      const hasRole = requiredRoles.some(r => userRoles.includes(r));

      if (!hasRole) {
        this.toasterService.error(
          'No tiene permisos para acceder a la ruta seleccionada',
          'Error',
          {
            positionClass: 'toast-bottom-right',
            progressAnimation: 'decreasing',
            progressBar: true
          }
        );

        await this.authService.signout();
        return false;
      }

      return true;
    }

    if (route.data && route.data.forAdmin) {
      if (this.authService.isAdmin) {
        return true;
      }

      this.toasterService.error(
        'No tiene permisos para acceder a la ruta seleccionada',
        'Error',
        {
          positionClass: 'toast-bottom-right',
          progressAnimation: 'decreasing',
          progressBar: true
        }
      );

      await this.authService.signout();
      return false;
    }

    return true;
  }
}
